export const EVER_STAGED_STEP_KEYS = ["S1", "S1_AI", "S1_EXTRACT", "S2"] as const;

const ACTIVE_ATTEMPT_STATUSES = new Set([
  "CREATED",
  "QUEUED",
  "RUNNING",
  "PENDING",
  "ENQUEUED",
]);

export interface EverStagedAttemptLike {
  step_key: string | null;
  records_out: number | null;
  merchant_source_id?: string | null;
  status?: string | null;
}

export function isEverStagedAttempt(attempt: EverStagedAttemptLike): boolean {
  const stepKey = String(attempt.step_key ?? "").toUpperCase();
  const status = String(attempt.status ?? "").toUpperCase();

  if (!EVER_STAGED_STEP_KEYS.includes(stepKey as (typeof EVER_STAGED_STEP_KEYS)[number])) return false;
  if ((attempt.records_out ?? 0) <= 0) return false;
  if (attempt.merchant_source_id != null) return false;
  if (ACTIVE_ATTEMPT_STATUSES.has(status)) return false;
  return true;
}

export function computeEverStagedFromAttempts(attempts: EverStagedAttemptLike[] | null | undefined): number {
  if (!attempts || attempts.length === 0) return 0;
  let maxOut = 0;
  for (const attempt of attempts) {
    if (!isEverStagedAttempt(attempt)) continue;
    maxOut = Math.max(maxOut, Math.max(0, attempt.records_out ?? 0));
  }
  return maxOut;
}
